import React from 'react';
import _ from 'lodash';

import SimpleModal from '../SimpleModal';

const BookedReceiveNumberModal = (props) => {
  return(
    <SimpleModal 
      isOpen={props.open}
      title={props.modalTitle}
      showSubmitButton={false}
      onClose={props.onClose}>
        {!props.show_warning ? (
          <div>
            <div className='row mb-3'>
              <div className='col-md-4 pt-2'>
                <strong>ประเภท</strong>
              </div>
              <div className='col-md-7'>
                {props.edit_booked_id ? (
                  <div>{props.selectedNumberType}</div>
                ) : (
                  <select 
                    value={props.selectedNumberType}
                    name='selectedNumberType'
                    className='form-control form-control-sm'
                    onChange={props.handleChange}>
                    {_.map(props.receiveNumberTypes, props.renderNumberTypeOption)}
                  </select>
                )}
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-4 pt-2'>
                <strong>หน่วยงาน</strong>
              </div>
              <div className='col-md-7'>
                {props.edit_booked_id ? (
                  <div>{_.get(props, 'group.attributes.name', '')}</div>
                ) : (
                  <select 
                    value={props.group_id}
                    name='group_id'
                    className='form-control form-control-sm'
                    onChange={props.handleChange}>
                    {(props.isDataFetched && _.isEmpty(props.groups)) && (
                      <option value=''>-- เลือกหน่วยงาน --</option>
                    )}
                    {(props.isDataFetched && !_.isEmpty(props.groups)) && _.map(props.groups, props.renderOption)}
                  </select>
                )}
                
              </div>
            </div>

            <div className='row mb-3'>
              <div className='col-md-4 pt-2'>
                <strong>จำนวนหนังสือที่จอง</strong>
              </div>
              <div className='col-md-3'>
                {props.edit_booked_id ? (
                  <div>{props.amount}</div>
                ) : (
                  <input 
                    type='text' 
                    value={props.amount}
                    name='amount'
                    className='form-control form-control-sm'
                    onChange={props.handleChange} />
                )}
              </div>
              <div className='col-md-4 pt-2'>
                เรื่อง
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-4 pt-2'>
                <strong>เรื่อง</strong>
              </div>
              <div className='col-md-8'>
                <input 
                  type='text' 
                  value={props.topic}
                  name='topic'
                  className='form-control form-control-sm'
                  onChange={props.handleChange} />
              </div>
            </div>
            <div className="modal-footer row">
              <button type='button' className="btn btn-primary pointer" onClick={props.confirm}>บันทึก</button>
              <button type='button' className="btn btn-secondary pointer" onClick={props.onClose}>ยกเลิก</button>
            </div>
          </div>
        ) : (
          <div>
            <div>
              คุณต้องการเพิ่มการจองเลข
            </div>
            {!_.isEmpty(props.group) ? (
              <div>
                ของหน่วยงาน <u>{props.group.attributes.name}</u>
              </div>
            ) : (
              <div>
                ของหน่วยงาน -
              </div>
            )}
            <div>
              ทั้งหมด {props.amount} เรื่อง
            </div>
            <div>
              เรื่อง {props.topic}
            </div>
            <div className="modal-footer row">
              {props.edit_booked_id ? (
                <button type='button' className="btn btn-primary pointer" onClick={props.handleUpdateBooked}>ยืนยัน</button>
              ) : (
                <button type='button' className="btn btn-primary pointer" onClick={props.handleSubmit}>ยืนยัน</button>
              )}
              <button type='button' className="btn btn-secondary pointer" onClick={props.onClose}>ยกเลิก</button>
            </div>
          </div>
        )}
    </SimpleModal>
  )
}

export default BookedReceiveNumberModal;


// WEBPACK FOOTER //
// ./src/components/documents/BookedReceiveNumberModal.js